import axios from 'axios';
import { CATALOG_BASE_URL } from '../constants';
import { downloadBlob, getJson, postForFile } from './batch3Api';

export { downloadBlob };

export interface PayrollOptions {
  formats: { key: string; label: string }[];
  fields: { key: string; label: string; required: boolean; formula?: boolean }[];
  /** Mapping value meaning "derive this field" (EE Pension = Net Pay - Take-Home Pay). */
  formula_value: string;
}

export interface HeaderScan {
  pdf: { columns: string[]; samples: { column: string; sample: string }[]; debug: string };
  excel: { columns: string[]; samples: { column: string; sample: string }[]; debug: string };
  suggestions: Record<string, string>;
}

export interface PayrollRunSummary {
  log: string;
}

export interface PayrollRunInput {
  pdfs: File[];
  excels: File[];
  nominal: File | null;
  trialBalance: File | null;
  directors: string;
  parseMode: 'auto' | 'manual';
  format: string;
  manualMap: Record<string, string>;
}

export function fetchPayrollOptions() {
  return getJson<PayrollOptions>('/payroll-agent/options', 'Could not load the payroll options');
}

export async function scanPayrollHeaders(pdfs: File[], excels: File[]): Promise<HeaderScan> {
  const form = new FormData();
  pdfs.forEach((f) => form.append('pdf_files', f));
  excels.forEach((f) => form.append('payroll_excel_files', f));
  try {
    return (await axios.post<HeaderScan>(`${CATALOG_BASE_URL}/payroll-agent/scan`, form)).data;
  } catch (error) {
    if (axios.isAxiosError(error) && typeof error.response?.data?.detail === 'string') {
      throw new Error(error.response.data.detail);
    }
    throw new Error('Could not scan the files.');
  }
}

export function runPayrollAgent(input: PayrollRunInput) {
  const form = new FormData();
  input.pdfs.forEach((f) => form.append('pdf_files', f));
  input.excels.forEach((f) => form.append('payroll_excel_files', f));
  if (input.nominal) form.append('nominal_file', input.nominal);
  if (input.trialBalance) form.append('tb_file', input.trialBalance);
  form.append(
    'options',
    JSON.stringify({
      directors: input.directors,
      parse_mode: input.parseMode,
      format: input.format,
      manual_map: input.manualMap,
    })
  );
  return postForFile<PayrollRunSummary>('/payroll-agent/run', form, 'Payroll Reconciliation.xlsx', 'Processing failed');
}
